module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2018_02.26690f4d.jpg";